import * as React from "react";
import { Box, CssBaseline, Typography } from "@mui/material";
import YoutubeContainer from "../components/YoutubeContainer";

export default function SceneComponent(props) {
  return (
    <YoutubeContainer id={props.video} />
    // <div>
    //   <div class="container" id="containerId">
    //     <iframe
    //       id="theFrame"
    //       class="responsive-iframe"
    //       src="https://player.vimeo.com/video/474897887"
    //       width="640"
    //       height="360"
    //       frameborder="0"
    //       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; fullscreen;"
    //       allowfullscreen
    //     ></iframe>
    //   </div>

    //   <script src="https://player.vimeo.com/api/player.js"></script>
    //   <script src="https://divergentes.appis.mx/js/dia2.js"></script>
    // </div>
  );
}
